import { useState } from 'react';
import { Link } from 'react-router-dom';
import TemplateRequestModal from './TemplateRequestModal';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function BrutalFooter() {
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <footer
      className="bg-white border-t border-black/10 pt-10 pb-0 overflow-hidden"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      <div className="max-w-[1400px] mx-auto px-5">
        {/* Top row */}
        <ScrollReveal direction="up" duration={700} delay={0} distance={28}>
          <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-10">
            {/* Left: about */}
            <div className="flex flex-col gap-1">
              <p className="text-sm text-black font-semibold">NOVA AI DIGITAL</p>
              <p className="text-sm text-black/50">Built by NOVA AI DIGITAL</p>
            </div>

            {/* Center: sitemap */}
            <nav className="flex flex-col gap-1">
              <Link to="/" className="text-sm text-black hover:opacity-50 transition-opacity whitespace-nowrap cursor-pointer">Index</Link>
              <Link to="/brutal-about" className="text-sm text-black hover:opacity-50 transition-opacity whitespace-nowrap cursor-pointer">About</Link>
              <button className="text-sm text-black hover:opacity-50 transition-opacity text-left cursor-pointer whitespace-nowrap">Search</button>
              <button onClick={() => setModalOpen(true)} className="text-sm text-black hover:opacity-50 transition-opacity text-left cursor-pointer whitespace-nowrap">Submit</button>
              <a href="mailto:hello@novaaidigital.com" className="text-sm text-black hover:opacity-50 transition-opacity whitespace-nowrap cursor-pointer">Contact</a>
            </nav>

            {/* Right: social */}
            <nav className="flex flex-col gap-1">
              <a href="https://www.instagram.com/novaaidigitalllc/" target="_blank" rel="noopener noreferrer" className="text-sm text-black hover:opacity-50 transition-opacity whitespace-nowrap cursor-pointer">Instagram</a>
              <a href="https://www.facebook.com/profile.php?id=61580586208643" target="_blank" rel="noopener noreferrer" className="text-sm text-black hover:opacity-50 transition-opacity whitespace-nowrap cursor-pointer">Facebook</a>
            </nav>
          </div>
        </ScrollReveal>
      </div>

      {/* Big NOVA AI text */}
      <ScrollReveal direction="up" duration={900} delay={100} distance={40}>
        <div className="w-full overflow-hidden">
          <p
            className="text-black font-black leading-none select-none whitespace-nowrap px-2"
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 'clamp(80px, 18vw, 280px)',
              letterSpacing: '-0.04em',
              lineHeight: 0.85,
            }}
          >
            NOVA AI
          </p>
        </div>
      </ScrollReveal>

      {/* Copyright bar */}
      <ScrollReveal direction="fade" duration={600} delay={200}>
        <div className="max-w-[1400px] mx-auto px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 border-t border-black/10 mt-4">
          <p className="text-xs text-black/40">ALL IMAGES AND VIDEOS ARE COPYRIGHTED BY THEIR ORIGINAL CREATORS</p>
          <p className="text-xs text-black/40">©{new Date().getFullYear()}</p>
        </div>
      </ScrollReveal>

      <TemplateRequestModal
        template={modalOpen ? { id: 0, name: 'Build My Website', category: 'Custom', tag: null, type: 'video', price: 15, priceId: 'template_standard', poster: '', video: '', externalUrl: '' } : null}
        onClose={() => setModalOpen(false)}
      />
    </footer>
  );
}
